<template>
  <div
    id="video_page_info"
    :class="{
      'category-195': item.main_category && item.main_category.id == 195,
      'full-width-image': item.main_category && item.main_category.id == 195 && item.pic_hero_parsed,
      'side-layout': item.main_category && item.main_category.id == 195 && !item.pic_hero_parsed,
    }"
  >
    <!-- Hero: poster image + play button (non-article) -->
    <VideoInfoHero
      v-if="!(item.main_category && item.main_category.id == 195)"
      :item="item"
      :is-user-can-watch="is_user_can_watch"
    />

    <!-- Tabs + content body -->
    <VideoInfoTabs
      :item="item"
      :seasons="seasons"
      :episode="episode"
      :menu-selected="menu_selected"
      :is-user-can-watch="is_user_can_watch"
      :article-credit="articleCredit"
      :related-articles="relatedArticles"
      @update:menuSelected="menu_selected = $event"
      :is-favorite="isFavorite"
      @addToFav="add_to_fav"
      @goToArticle="goToArticle"
    >
      <template #item-tpl="{ item: episodeItem }">
        <itemTpl :item="episodeItem" />
      </template>
    </VideoInfoTabs>
  </div>
</template>

<script>
import itemTpl from './item_tpl.vue';
import VideoInfoHero from './video_info/VideoInfoHero.vue';
import VideoInfoTabs from './video_info/VideoInfoTabs.vue';

export default {
  components: { itemTpl, VideoInfoHero, VideoInfoTabs },

  props: {
    options: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  // eslint-disable-next-line no-unused-vars
  data() {
    return {
      id: this.$route.params.id,
      eid: this.$route.params.eid,
      episode: {},
      seasons: [],
      item: {},
      cur_season: {},
      next_episode: {},
      menu_selected: 'trailers',
      user_token: localStorage.getItem('user_token'),
      isFavorite: false,
      utm_source: localStorage.getItem('utm_source') ? localStorage.getItem('utm_source') : '',
      utm_medium: localStorage.getItem('utm_medium') ? localStorage.getItem('utm_medium') : '',
      utm_campaign: localStorage.getItem('utm_campaign') ? localStorage.getItem('utm_campaign') : '',
      relatedArticles: [],
    };
  },

  computed: {
    is_user_can_watch() {
      // Category 195 is public — no login required
      if (this.item.main_category && this.item.main_category.id == 195) {
        return true;
      }
      if (!this.get_me) {
        return false;
      }
      if (this.get_me.is_active == true) return true;
      return false;
    },
    // Credit comes from the CMS field only — empty means "render nothing".
    articleCredit() {
      return this.item && this.item.credit ? String(this.item.credit).trim() : '';
    },
  },

  watch: {
    item: {
      handler() {
        this.updateMetaTags();
      },
      deep: true,
    },
  },

  created() {
    var self = this;
    this.api_call({
      url: 'items/get',
      data: { id: this.id, eid: this.eid, parse_extended: true },
      onComplete: function (data) {
        self.seasons = data.data.data.seasons;
        self.cur_season = self.seasons[0];
        self.item = data.data.data;
        self.isFavorite = !!data.data.data.is_favorite;

        // Category 195: redirect to article route
        if (self.item.main_category && parseInt(self.item.main_category.id) === 195) {
          self.loadRelatedArticles();
          self.$router.push('/article/' + self.item.id);
          return;
        }

        if (self.item.type === 'series') {
          self.menu_selected = 'trailers';
        } else {
          self.menu_selected = 'info';
        }

        document.title =
          self.item.title && self.item.title !== ''
            ? self.item.title + ' | אקטואליה יהודית - TOV+'
            : 'TOV+ ערוץ תקשורת יהודי';

        self.episode = data.data.data.episode;
        self.updateMetaTags();

        if (localStorage.getItem('user_restrictions') === null) {
          localStorage.setItem('user_restrictions', JSON.stringify({}));
        }

        self.user_restrictions = JSON.parse(localStorage.getItem('user_restrictions'));
        for (let season_i in self.seasons) {
          for (let episode_i in self.seasons[season_i].episodes) {
            for (let rest_cat_i in self.seasons[season_i].episodes[episode_i].restrictions) {
              for (let rest_i in self.seasons[season_i].episodes[episode_i].restrictions[rest_cat_i].items) {
                const restItem = self.seasons[season_i].episodes[episode_i].restrictions[rest_cat_i].items[rest_i];
                restItem.is_checked = self.user_restrictions[restItem.id] === true;
              }
            }
          }
        }
      },
    });
  },

  mounted() {
    this.updateMetaTags();
  },

  methods: {
    add_to_fav(id) {
      if (!this.get_me || !this.get_me.id) {
        this.$store.commit('open_signup', { step: 1, plan_id: 0 });
        return;
      }

      const userToken = localStorage.getItem('user_token');
      if (!userToken) {
        this.$store.commit('open_signup', { step: 1, plan_id: 0 });
        return;
      }

      if (this.isFavorite) {
        this.$http.post(window.api_url + 'user/remove_favorite', {
          item_id: id,
          api_user_token: userToken,
        }).then(() => {
          this.isFavorite = false;
          this.$alert('הסרט הוסר מרשימת הצפייה שלך');
        }).catch(() => {
          this.$alert('לא הצלחנו להסיר מהמועדפים, נסו שוב.');
        });
      } else {
        this.$http.post(window.api_url + 'user/add_favorite', {
          item_id: id,
          api_user_token: userToken,
        }).then(() => {
          this.isFavorite = true;
          this.$alert('הסרט נוסף לרשימת הצפייה שלך');
        }).catch(() => {
          this.$alert('לא הצלחנו להוסיף למועדפים, נסו שוב.');
        });
      }
    },

    goToArticle(articleId) {
      this.$router.push('/article/' + articleId);
    },

    rest_change(id, e) {
      this.user_restrictions[id] = e.target.checked;
      localStorage.setItem('user_restrictions', JSON.stringify(this.user_restrictions));
    },

    updateMetaTags() {
      let description =
        this.item.seo_description ||
        this.item.full_description ||
        this.item.description ||
        this.item.content ||
        this.item.text ||
        'TOV+ - תוכן פרימיום מקורי שלא תמצאו בשום מקום אחר!';

      if (description.length > 160) {
        description = description.substring(0, 157) + '...';
      }

      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.name = 'description';
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute('content', description);

      this.updateOpenGraphTag('og:description', description);
      this.updateOpenGraphTag('twitter:description', description);
    },

    updateOpenGraphTag(property, content) {
      if (!content) return;
      let meta = document.querySelector(`meta[property="${property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.content = content;
    },


    loadRelatedArticles() {
      if (!this.item.main_category || !this.item.main_category.id) return;
      this.api_call({
        url: 'items/get_by_category',
        data: {
          category_id: this.item.main_category.id,
          limit: 6,
          exclude_id: this.id,
        },
        onComplete: (data) => {
          const articles = data.data.data || [];
          if (Array.isArray(articles)) {
            this.relatedArticles = articles.filter(a => a.id !== this.id);
          } else {
            this.relatedArticles = [];
          }
        },
        onError: () => {
          this.relatedArticles = [];
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* Shell-level styles only — subcomponent styles are scoped within each file */

#video_page_info.category-195 .article-body .content {
  font-size: 16px;
  line-height: 1.5;
  color: var(--color-text);
  text-align: start;
  direction: rtl;
}

#video_page_info.category-195 .article-image img {
  inline-size: 100%;
  max-inline-size: 850px;
  border-radius: var(--radius-md);
  margin-block-end: var(--space-6);
}

#video_page_info.category-195 .article-header h1 {
  color: var(--color-text);
  font-size: 28px;
  margin-block-end: var(--space-3);
}

#video_page_info.category-195 .article-meta {
  color: var(--color-textMuted);
  font-size: 14px;
  margin-block-end: var(--space-6);
}
</style>
